import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enLocales from '../languages/en.json';
import trLocales from '../languages/tr.json';


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      tr: { translations: trLocales },
    },
    // lng: localStorage.getItem('i18nextLng') || navigator.language.substring(0, 2),
    lng: localStorage.getItem('i18nextLng') || "en",
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
